import { Navigate, useParams } from 'react-router-dom';

import NotFound from './NotFound';
import {
  isTokenValid,
  hasVinculo,
  canUserAccessTenant,
  getActiveInterface,
  getRouteForInterface,
  VALID_TENANTS,
} from '../modules/contexts/Auth/RequireAuth';
import AppDAF from '../pages/daf/AppDAF';
import AppFornecedor from '../pages/fornecedor/AppFornecedor';
import AppSES from '../pages/ses/AppSES';

const TenantRouter = () => {
  const { tenant } = useParams();

  if (!isTokenValid()) return <Navigate to="/" replace />;

  if (!tenant || !VALID_TENANTS.includes(tenant)) return <NotFound />;

  if (!hasVinculo()) {
    const rotaCorreta = getRouteForInterface(getActiveInterface());
    return <Navigate to={rotaCorreta} replace />;
  }

  if (!canUserAccessTenant(tenant)) {
    const rotaCorreta = getRouteForInterface(getActiveInterface());
    return <Navigate to={rotaCorreta} replace />;
  }

  switch (tenant) {
    case 'daf':
      return <AppDAF />;
    case 'fornecedor':
      return <AppFornecedor />;
    case 'secsaude':
      return <AppSES />;
    default:
      return <NotFound />;
  }
};

export default TenantRouter;
